import { useEffect } from 'react';

const useDocumentTitle = (title: string) => {
    useEffect(() => {
        document.title = `Interpals | ${title}`;

        return () => {
            // Revert to some default title if you'd like when the component unmounts
            document.title = 'InterPals: Meet the World. Make friends, travel and learn languages today!';
        };
    }, [title]);
};

export default useDocumentTitle;
